export enum GroupStyle {
  Default = 10,
  SubGroup = 20,
  CenterGroup = 30,
  FormCard = 40,
}
